import { Badge, Container, Group, Loader, Paper, Table, Text, Tooltip } from "@mantine/core"
import { IconInfoCircle } from "@tabler/icons-react"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/PageHeader"
import { queries } from "@/lib/queries"

export const Route = createFileRoute("/qsbs")({
  component: QsbsTracker,
})

const DEMO_INVESTOR_ID = "019577a0-0000-7000-8000-000000000001"

function QsbsTracker() {
  const { data, isPending, isError } = useQuery(queries.investorQsbs(DEMO_INVESTOR_ID))

  return (
    <Container size="xl">
      <PageHeader eyebrow="Tax · Section 1202">QSBS Tracker</PageHeader>

      {isPending ? (
        <Loader />
      ) : isError ? (
        <Text c="var(--pitch-negative)">Failed to load QSBS data</Text>
      ) : data.companies.length === 0 ? (
        <Paper withBorder p="xl" radius={0} style={{ borderColor: "var(--pitch-border)" }}>
          <Text c="var(--pitch-text-tertiary)">No QSBS data available for your portfolio.</Text>
        </Paper>
      ) : (
        <Paper withBorder p="md" radius={0} style={{ borderColor: "var(--pitch-border)" }}>
          {data.taxResidencyState.fold(
            () => null,
            (state) => (
              <Text size="sm" c="var(--pitch-text-tertiary)" mb="md">
                Tax Residency: {state}
              </Text>
            ),
          )}
          <Table striped highlightOnHover>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Company</Table.Th>
                <Table.Th>QSBS Eligible</Table.Th>
                <Table.Th>
                  <Group gap={4} wrap="nowrap">
                    <span>Tax Savings ($M)</span>
                    <Tooltip
                      multiline
                      w={260}
                      withArrow
                      label="Relevant for US taxable investors only. Non-US investors should consult their tax advisors."
                    >
                      <IconInfoCircle size={14} style={{ cursor: "help" }} aria-label="Tax savings disclosure" />
                    </Tooltip>
                  </Group>
                </Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {data.companies.map((co) => (
                <Table.Tr key={co.companyId}>
                  <Table.Td fw={600}>{co.companyId.toUpperCase()}</Table.Td>
                  <Table.Td>
                    <Badge size="xs" color={co.qsbsEligible ? "pitchPositive" : "pitchNegative"}>
                      {co.qsbsEligible ? "Eligible" : "Not Eligible"}
                    </Badge>
                  </Table.Td>
                  <Table.Td className="pitch-tabular">
                    {co.taxSavings.fold(
                      () => "—",
                      (t) => t.taxSavingsM,
                    )}
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Paper>
      )}
    </Container>
  )
}
